import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataSyncService } from '../../../../../core/model-wizard/_services/data-sync.service';

@Component({
  selector: 'kt-delete-entity-input-popup',
  templateUrl: './delete-entity-input-popup.component.html',
  styleUrls: ['./delete-entity-input-popup.component.scss']
})
export class DeleteEntityInputPopupComponent implements OnInit {

  confirmText: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<DeleteEntityInputPopupComponent>,
  private dataSyncService: DataSyncService,
  private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
  }

  deleteHandler(event) {
    this.dataSyncService.deleteSystemData(this.data ? this.data.id : "", true).subscribe((res: any) => {
      if (res.status == 200) {
        // this._snackBar.open(this.data.snackBarMessage , "x", { "duration": 3000 });
        // setTimeout(() => location.reload(), 3000)
        this.dialogRef.close(res)
      } else {
        this._snackBar.open("Something went wrong", "x", { "duration": 3000 });
      }
    })
  };
}
